import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import {
    PrestadorServicoChefeTecnicoSalvarRequest,
    PrestadorServicoDetalheResponse,
    PrestadorServicoEspecialidadeSalvarRequest,
    PrestadorServicoMedicoSalvarRequest,
    PrestadorServicoOpcaoResponse,
    PrestadorServicosEspecialidadesResponse
} from '@/core/api/sicom-api/registro/prestador/prestador-servicos-especialidades.model';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class PrestadorServicosEspecialidadesService extends BaseService {
    readonly PATH = SICOM_PATHS.registro.prestador.servicosEspecialidades;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    buscar(params: Pessoa, exibirTransicao = false, context?: HttpContext): Observable<PrestadorServicosEspecialidadesResponse> {
        const httpParams = new HttpParams().set('id', String(params.id)).set('uf', String(params.uf)).set('exibirTransicao', String(exibirTransicao));
        return this.http.get<PrestadorServicosEspecialidadesResponse>(this.PATH, { params: httpParams, context });
    }

    listarServicos(context?: HttpContext): Observable<PrestadorServicoOpcaoResponse[]> {
        return this.http.get<PrestadorServicoOpcaoResponse[]>(`${this.PATH}/servicos`, { context });
    }

    buscarDetalheServico(params: Pessoa, idServico: number, context?: HttpContext): Observable<PrestadorServicoDetalheResponse> {
        const httpParams = new HttpParams().set('id', String(params.id)).set('uf', String(params.uf)).set('idServico', String(idServico));
        return this.http.get<PrestadorServicoDetalheResponse>(`${this.PATH}/servico/detalhes`, { params: httpParams, context });
    }

    salvarServico(request: PrestadorServicoMedicoSalvarRequest): Observable<PrestadorServicosEspecialidadesResponse> {
        return this.http.put<PrestadorServicosEspecialidadesResponse>(`${this.PATH}/servico`, request);
    }

    removerServico(request: PrestadorServicoMedicoSalvarRequest): Observable<PrestadorServicosEspecialidadesResponse> {
        return this.http.delete<PrestadorServicosEspecialidadesResponse>(`${this.PATH}/servico`, { body: request });
    }

    salvarEspecialidade(request: PrestadorServicoEspecialidadeSalvarRequest): Observable<PrestadorServicosEspecialidadesResponse> {
        return this.http.put<PrestadorServicosEspecialidadesResponse>(`${this.PATH}/especialidade`, request);
    }

    removerEspecialidade(request: PrestadorServicoEspecialidadeSalvarRequest): Observable<PrestadorServicosEspecialidadesResponse> {
        return this.http.delete<PrestadorServicosEspecialidadesResponse>(`${this.PATH}/especialidade`, { body: request });
    }

    salvarChefeTecnico(request: PrestadorServicoChefeTecnicoSalvarRequest): Observable<PrestadorServicosEspecialidadesResponse> {
        return this.http.put<PrestadorServicosEspecialidadesResponse>(`${this.PATH}/chefe-tecnico`, request);
    }

    removerChefeTecnico(request: PrestadorServicoChefeTecnicoSalvarRequest): Observable<PrestadorServicosEspecialidadesResponse> {
        return this.http.delete<PrestadorServicosEspecialidadesResponse>(`${this.PATH}/chefe-tecnico`, { body: request });
    }
}
